import React from "react";
import { Grid, Typography } from "@mui/material";

const ResultItem = ({ label, value, title, boldLabel = false }) => (
  <>
    <Grid item xs={6}>
      <Typography
        variant="body2"
        sx={{ fontWeight: boldLabel ? "bold" : "normal" }}
      >
        {label}:
      </Typography>
      {title && (
        <Typography variant="caption" color="text.secondary" display="block">
          {title}
        </Typography>
      )}
    </Grid>
    <Grid item xs={6}>
      <Typography variant="body2" sx={{ fontWeight: "bold" }}>
        {isNaN(value)
          ? value
          : `₹${(value || 0).toLocaleString("en-IN", {
              maximumFractionDigits: 2,
            })}`}
      </Typography>
    </Grid>
  </>
);

export default ResultItem;
